function FilterReferenceFieldController($scope, $parse) {
	var self = this;
	this.items = null;
	this.dictInitialized = false;
	this.update_dict = function() {
		if (!self.items) {
			return $scope.cls[$scope.field.name + '__dict']({
				filter:{},
				data: {}
			}).then(function(dict){
				self.items = dict
				self.dictInitialized = true;
			});
		} else {
			return self.items;
		}
	}
	this.update_dict();
	
	this.make_title = function(object) {
		var field = $scope.field;
		if (field.client && field.client.title) {
			var title_expr = field.client.title;
			var title = $parse(field.client.title);
			return title(object, window);
		} else {
			return object? object.__title : null;
		}
	}
	
	this.titleForKey = function(dict, key) {
		for (var i in dict) {
			if (dict[i].__id == key) return this.make_title(dict[i]);
		}
		return null;
	}
	
	this.allTitles = function(dict, values) {
		var titles = [];
		for (var i in values) {
			var key = values[i];
			titles.push(self.titleForKey(dict, key));
		}
		return titles.join(', ');
	}
	
	this.toggleOption = function(values, option) {
		if (!values) return;
		var pos = values.indexOf(option);
		if (pos >= 0) {
			values.splice(pos,1);
		} else {
			values.push(option);
		}
		
		return values;
	}
	
	this.hasOption = function(values, option) {
		if (!values) return false;
		return (values||[]).indexOf(option) >= 0;
	}
	
	window['fr_' + $scope.field.name] = this;
}

angular.module('forms.fields.filterreference', [])
.controller('FilterReferenceFieldController', FilterReferenceFieldController);